import http from '../../services/http-common';

class SecurityService {
  constructor() {
    this.authenticated = false;
  }

  isAuthenticated() {
    return localStorage.getItem('login') !== null;
  }

  // I want to set this.authenticated to true on successful login
  authenticateUser(data) {
    return http.post('/security/authenticateUser', data);
  }

  changePassword(data) {
    return http.post('/security/changePassword', data);
  }

  verifyEmail(data) {
    return http.post('/security/verifyEmail', data);
  }

  getLoggedInUser() {
    const loggedInUser = JSON.parse(localStorage.getItem('login'));
    console.log('login user detail' ,  loggedInUser)
    if(loggedInUser?.username){
      return loggedInUser.username;
    }
    return 'Unknown';
  }
  getLoggedInShopID() {
    const loggedInUser = JSON.parse(localStorage.getItem('login'));
    console.log('login user detail' ,  loggedInUser.ShopID)
    if(loggedInUser?.ShopID){
      return loggedInUser.ShopID;
    }
    return null
  }

  getLoggedInUserId() {
    const loggedInUser = JSON.parse(localStorage.getItem('login'));
    console.log(loggedInUser)
    return loggedInUser?.userId;
  }

  getCompanyIDLoggedInUserId() {
    const loggedInUser = JSON.parse(localStorage.getItem('login'));
    console.log(loggedInUser)
    console.log('localStorage', localStorage)
    return loggedInUser?.CompanyID;
  }
  getCompanyNameLoggedInUserId() {
    const loggedInUser = JSON.parse(localStorage.getItem('login'));
    console.log(loggedInUser)
    console.log('localStorage', localStorage)
    return loggedInUser?.CompanyName;
  }

  getCompanyLogo(ntn){
    return http.get(`/Seller/getLogo?NTN=${ntn}`);
  }
  getCompanyImage() {
    const CompanyImage = localStorage.getItem('CompanyImage');
    console.log(CompanyImage)
    console.log('CompanyImage', CompanyImage)
    return CompanyImage ?? 'https://placehold.net/400x400.png';
  }
  getFurtherTaxDefaultValue() {
    const FurtherTaxValue = JSON.parse(localStorage.getItem('FurtherTaxValue'));
    console.log(FurtherTaxValue)
    console.log('localStorage', localStorage)
    return FurtherTaxValue;
  }


  getShowSaleChallan = () => {
    const companyId = this.getCompanyIDLoggedInUserId();
  
    return http.get(`security/getShowSaleChallan?CompanyID=${companyId}`)
      .then((res) => {
        const row = res?.data?.recordset?.[0] ?? null;
        let isExist =  (row?.IsExist ?? 0) === 1;
        console.log(isExist)
        return isExist;
      })
      .catch((error) => {
        console.error("Error fetching getShowSaleChallan:", error);
        return false;
      });
  };
  getShowSaleChallanPopupOnSaleInvoice = () => {
    const companyId = this.getCompanyIDLoggedInUserId();
  
    return http.get(`security/getShowSaleChallanPopupOnSaleInvoice?CompanyID=${companyId}`)
      .then((res) => {
        const row = res?.data?.recordset?.[0] ?? null;
        let isExist =  (row?.IsExist ?? 0) === 1;
        console.log(isExist)
        return isExist;
      })
      .catch((error) => {
        console.error("Error fetching getShowSaleChallanPopupOnSaleInvoice:", error);
        return false;
      });
  };
  
  

  canUserAccess(itemName) {
    if (itemName) {
      const accessList = JSON.parse(localStorage.getItem('userAccessList'));
      console.log('loggedInUserAccessList:', accessList);
      console.log('ItemName:', itemName);
  
      // Find the item in accessList that matches the itemName (FormName) and return permissions as an object
      const item = accessList?.find(item => item.FormName === itemName && this.getLoggedInUserId() == item.UserID);
      console.log(item)
      if (item) {
        return {
          List: item.CanSELECT == 1, 
          Add: item.CanINSERT == 1,
          Edit: item.CanUPDATE == 1,
          Delete: item.CanDELETE == 1
        };
      }else{
      // If item is not found, return all permissions as false
      return {
        List: false,
        Add: false,
        Edit: false,
        Delete: false
      };
    }
    } else {
      // If itemName is not provided, return all permissions as false
      return {
        List: false,
        Add: false,
        Edit: false,
        Delete: false
      };
    }
  }
  
  userLog = async () => {
    var dat
 await  http.get('security/os').then((res)=>{
      console.log(res)
 dat = res.data
    })
    return dat
  }

  getUserAccessList(userId,CompanyID = this.getCompanyIDLoggedInUserId()) {
    return http.get(`/security/accessList/${CompanyID}/${userId}`);
  }
  getFurtherTaxValue(CompanyID = this.getCompanyIDLoggedInUserId()) {
    return http.get(`/security/FurtherTaxValue/${CompanyID}`);
  }
  
  getUserAccessListSingleLine(userId) {
    return http.get(`/security/accessList/singleLine/${userId}`);
  }

  getSecurityItems() {
    return http.get(`/security/items`);
  }

  getSecurityItemTypes() {
    return http.get(`/security/itemTypes`);
  }

  addSecurityItem(data) {
    return http.post(`/security/items/add`, data);
  }

  changeAccess(data) {
    console.log(data);
    return http.post(`/security/changeAccess`, data);
  }

  changeAccessMenu(data , id) {
    console.log(data);
    return http.post(`/security/changeAccess/menu/${id}`, data);
  }
  changeAccessList(data , id) {
    console.log(data);
    return http.post(`/security/changeAccess/list/${id}`, data);
  }
  changeAccessEdit(data , id) {
    console.log(data);
    return http.post(`/security/changeAccess/edit/${id}`, data);
  }
  changeAccessAdd(data , id) {
    console.log(data);
    return http.post(`/security/changeAccess/add/${id}`, data);
  }
  changeAccessDelete(data , id) {
    console.log(data);
    return http.post(`/security/changeAccess/delete/${id}`, data);
  }
  changeAccessReports(data , id) {
    console.log(data);
    return http.post(`/security/changeAccess/reports/${id}`, data);
  }
  getReportsUserAccess(userId) {
    return http.get(`/security/accessList/reports/${userId}`);
  }
 CompanyIP (){
       return http.get(`/security/company/ip`)
}
emailSend(data) {
  return http.post('/mail/pass', data);
}
getIP() {
  return http.get('https://api64.ipify.org?format=json');
}

 OpeningDate = async () => {
  try {
    const response = await http.get('security/company/openingDate');
    console.log(response.data.recordset[0].OpeningDate);
    return response.data.recordset[0].OpeningDate;
  } catch (error) {
    console.error('Error fetching opening date:', error);
    throw error; // Rethrow the error to be handled by the caller
  }
};

ReportServerPath = async () => {
  try {
    const response = await http.get('security/ReportServerPath');
    console.log(response.data.recordset[0].ReportServerPath);
    return response.data.recordset[0].ReportServerPath;
  } catch (error) {
    console.error('Error fetching opening date:', error);
    throw error; // Rethrow the error to be handled by the caller
  }
};


}
export default new SecurityService();
